<template>
  <section class="contact p-3" id="contact-form" tabindex="0" @focus="handleFocus">
    <div class="row">
      <div class="col-md-7">
        <div class="image-bg h-100"></div>
      </div>
      <div class="col-md-5 p-4 pr-md-5 pb-5 pt-3">
        <p class="w-fw-500">{{ $t('Kontaktný formulár') }}</p>
        <h2 v-if="this.stage == 'druzstevne' || this.selectedStage == 'bory4' || this.building == 'B2'" class="w-fw-300">Máte záujem o Bory Družstevné bývanie?</h2>
        <h2 v-else class="w-fw-300">{{ $t('Chcem vedieť viac') }}</h2>
        <div v-if="this.stage == 'druzstevne' || this.selectedStage == 'bory4' || this.building == 'B2'">
          <p>Predregistrujte sa prostredníctvom formulára a pri spustení možnosti získania členského podielu v družstve vás budeme kontaktovať podľa poradia registrácie.</p>
        </div>
        <div v-else>
          <p class="m-0">{{ $t('Zaujala vás ponuka bytov alebo sa chcete poradiť?') }}</p>
          <p class="m-0">{{ $t('Nechajte nám na seba kontakt a čoskoro sa vám ozveme.') }}</p>
        </div>
        <b-form class="mt-4" novalidate @submit.stop.prevent="sendForm">
          <div class="d-flex name-wrapper">
            <b-form-input v-model="v$.contactForm.name.$model" :placeholder="$t('Meno')" class="rounded-0" :state="validateState('name')" ref="inputName" type="text"></b-form-input>
            <b-form-input v-model="v$.contactForm.surname.$model" :placeholder="$t('Priezvisko')" class="rounded-0" :state="validateState('surname')"></b-form-input>
          </div>
          <b-form-input type="email" v-model="v$.contactForm.email.$model" :placeholder="$t('E-mail')" class="rounded-0 my-2" :state="validateState('email')"></b-form-input>
          <VuePhoneNumberInput 
            v-model="vuePhone.phone" 
            size="lg" 
            v-bind="vuePhone.props"
            @update="onUpdate"
          />
          <div class="custom-alert-box alert mt-3 alert-danger" v-if="v$.$errors.length || vuePhone.phone && !vuePhone.isValid">
            <div v-for="error of v$.$errors" :key="error.$uid">
              <p v-if="error.$property == 'name' && error.$validator == 'minLength'">{{ $t('Meno') }} - {{ $t('minimálny počet znakov') }}: 3</p>
              <p v-if="error.$property == 'name' && error.$validator == 'onlyString'">{{ $t('Meno') }} - {{ $t('obsahuje nepovolené znaky') }}</p>
              <p v-if="error.$property == 'name' && error.$validator == 'required'">{{ $t('Meno') }} - {{ $t('povinné pole') }}</p>
              <p v-if="error.$property == 'surname' && error.$validator == 'minLength'">{{ $t('Priezvisko') }} - {{ $t('minimálny počet znakov') }}: 3</p>
              <p v-if="error.$property == 'surname' && error.$validator == 'onlyString'">{{ $t('Priezvisko') }} - {{ $t('obsahuje nepovolené znaky') }}</p>
              <p v-if="error.$property == 'surname' && error.$validator == 'required'">{{ $t('Priezvisko') }} - {{ $t('povinné pole') }}</p>
              <p v-if="error.$property == 'email' && error.$validator == 'email'">Email - nesprávny formát</p>
              <p v-if="error.$property == 'email' && error.$validator == 'required'">Email - {{ $t('povinné pole') }}</p>
            </div>
            <p v-if="vuePhone.phone && !vuePhone.isValid">Telefónne číslo je neplatné</p>
          </div>
          <b-form-group class="mb-4" v-if="showInterestsDropdowns">
            <p class="mt-3">Ak máte záujem o kúpu bytu, vyberte, v ktorom projekte</p>
            <div class="position-relative">
              <div class="dropdown d-flex justify-content-between" @click="showDropdown()">
                <div class="d-flex">
                  <div v-if="!contactForm.interests.length">{{ $t('Vybrať projekt') }}</div>
                  <div v-if="contactForm.interests.includes('bory2b')">Bory Nový Dvor &nbsp;</div>
                  <div v-if="contactForm.interests.includes('bory3')">Bory Promenáda &nbsp;</div>
                  <div v-if="contactForm.interests.includes('bory4')">Bory Na Hrádzi&nbsp; &nbsp;</div>
                  <div v-if="contactForm.interests.includes('bory5')">Bory Nádvorie</div>
                  <div v-if="contactForm.interests.includes('bory3b')">Bory Nádvorie</div>
                  <div v-if="contactForm.interests.includes('boryNoveBloky')">Bory Nové Bloky</div>
                </div>
                <div>
                  <svg data-v-46e105de="" mlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="country-selector__toggle__arrow"><path data-v-46e105de="" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" class="arrow"></path><path data-v-46e105de="" fill="none" d="M0 0h24v24H0V0z"></path></svg>
                </div>
              </div>
              <b-form-checkbox-group v-model="interestsKupa" name="radio-sub-component" class="dropdown-content" :class="{active: dropdownActive}">
                <b-form-checkbox value="bory3b" size="lg" class="check-label">Bory Nádvorie</b-form-checkbox>
                <b-form-checkbox value="boryNoveBloky" size="lg" class="check-label">Bory Nové Bloky</b-form-checkbox>
              </b-form-checkbox-group>
              <b-alert v-if="this.v$.contactForm['interests'].$error" class="mt-3" show variant="danger">{{ $t('Vyberte etapu/ etapy, o ktoré máte záujem.') }}</b-alert>
            </div>
          </b-form-group>
          <b-form-group class="mb-4" v-if="showInterestsDropdowns">
            <p class="mt-3">Ak máte záujem o družstevné bývanie, vyberte, v ktorom projekte</p>
            <div class="position-relative">
              <div class="dropdown d-flex justify-content-between" @click="showDropdownDruzstevne()">
                <div class="d-flex">
                  <div v-if="!contactForm.interests.length">Vybrať projekt</div>
                  <div v-if="contactForm.interests.includes('druzstevne')">Bory Na Hrádzi&nbsp;</div>
                </div>
                <div>
                  <svg data-v-46e105de="" mlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="country-selector__toggle__arrow"><path data-v-46e105de="" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" class="arrow"></path><path data-v-46e105de="" fill="none" d="M0 0h24v24H0V0z"></path></svg>
                </div>
              </div>
              <b-form-checkbox-group v-model="interestsDruzstevne" name="radio-druzstevne" class="dropdown-content" :class="{active: dropdownDruzstevneActive}">
                <b-form-checkbox value="druzstevne" size="lg" class="check-label">Bory Na Hrádzi</b-form-checkbox>
              </b-form-checkbox-group>
              <b-alert v-if="this.v$.contactForm['interests'].$error" class="mt-3" show variant="danger">{{ $t('Vyberte etapu/ etapy, o ktoré máte záujem.') }}</b-alert>
            </div>
          </b-form-group>
          <b-form-checkbox
              id="terms"
              name="checkbox-1"
              :value="true"
              :unchecked-value="false"
              v-model="contactForm.marketing_consent"
              size="lg"
              class="mb-3 small-font terms-check"
              required
          >
            <p class="text-small m-0" v-html="$t('Súhlasím so zasielaním marketingových informácií vrátane reklamy elektronickou poštou alebo prostredníctvom SMS, aby mi neunikla žiadna novinka.')"></p>
          </b-form-checkbox>
          <div class="mb-4">
            <a class="mr-3 d-block d-md-inline" v-b-modal.agreements>{{ $t('Spracovanie osobných údajov') }}</a>
            <a class="mr-3" v-b-modal.cookies>{{ $t('Cookies') }}</a>
          </div>
          <div class="recaptcha" :class="{active: recaptchaActive}">
            <vue-recaptcha ref="recaptcha" @verify="onVerify" language="sk" :loadRecaptchaScript="true" sitekey="6LdGTd8ZAAAAAMVM63Wg5RyXBuImvgZpTcG-K7CV"></vue-recaptcha>
          </div>
          <b-button squared type="submit" variant="primary" class="mt-3">{{ $t('Odoslať') }}</b-button>
        </b-form>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"
import VueRecaptcha from 'vue-recaptcha'
import cookies from '@/plugins/cookie-banner/getCookie'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { email, required, requiredIf, minLength, helpers } from '@vuelidate/validators';
// import { helpers } from 'vuelidate/lib/validators'
import { useVuelidate } from '@vuelidate/core';
const alpha = helpers.regex(/^[a-zA-Z \u00C0-\u024F]*$/)

const ua = navigator.userAgent

function getBrowser(ua) {
  if (ua.includes("Firefox/")) return "Firefox"
  if (ua.includes("Edg/")) return "Edge"
  if (ua.includes("Chrome/") && !ua.includes("Edg/")) return "Chrome"
  if (ua.includes("Safari/") && !ua.includes("Chrome/")) return "Safari"
  return "Unknown"
}

function getOS(ua) {
  if (ua.includes("Win")) return "Windows"
  if (ua.includes("Mac")) return "macOS"
  if (ua.includes("X11") || ua.includes("Linux")) return "Linux"
  if (ua.includes("Android")) return "Android"
  if (ua.includes("iPhone") || ua.includes("iPad")) return "iOS"
  return "Unknown"
}

export default {
  setup: () => ({ v$: useVuelidate() }),
  name: "ContactForm",
  components: { 'vue-recaptcha': VueRecaptcha, VuePhoneNumberInput },
  props: ['internalId', 'stage', 'building', 'selectedStage'],
  data() {
    return {
      preSelectedB2: false,
      preSelectedB3: false,
      preSelectedB4: false,
      preSelectedB5: true,
      state: null,
      yourValue: null,
      dropdownActive: false,
      dropdownDruzstevneActive: false,
      recaptchaActive: false,
      vuePhone: {
        phone: "",
        isValid: false,
        props: {
          clearable: true,
          preferredCountries: ["SK", "CZ", "AT", "PL"],
          defaultCountryCode: "SK",
          noExample: false,
          noFlags: true,
          error: false,
          translations: {
            countrySelectorLabel: this.$t('Kód krajiny'),
            countrySelectorError: "Chyba",
            phoneNumberLabel: this.$t('Telefónne číslo'),
            example: "Napríklad:"
          }
        }
      },
      contactForm: {
        "ga_client_id": "",
        "name": "",
        "surname": "",
        "email": "",
        "phone": "",
        "interests": [],
        "marketing_consent": false,
        "g-recaptcha-response": "",
        "internal_id": ""
      },
      validation: false,
      interestsError: false
    }
  },
  validations() {
    return {
      contactForm: {
        name: {
          required,
          minLength: minLength(3),
          onlyString: alpha
        },
        surname: {
          required,
          minLength: minLength(3),
          onlyString: alpha
        },
        email: { required, email },
        interests: {
           required: requiredIf(function() {
            if (this.internalId) return false;
            if (this.stage === 'druzstevne') return false;
            if (this.selectedStage === 'bory4') return false;
            return true;
           })
        }
      }
    }
  },
  computed: {
    interestsKupa: {
      get() {
        return this.contactForm.interests.filter(i => i !== 'druzstevne')
      },
      set(val) {
        const druzstevne = this.contactForm.interests.filter(i => i === 'druzstevne')
        this.contactForm.interests = [...val, ...druzstevne]
      }
    },
    interestsDruzstevne: {
      get() {
        return this.contactForm.interests.filter(i => i === 'druzstevne')
      },
      set(val) {
        const others = this.contactForm.interests.filter(i => i !== 'druzstevne')
        this.contactForm.interests = [...others, ...val]
      }
    },
    showInterestsDropdowns() {
      return !this.internalId && this.stage !== 'druzstevne' && this.selectedStage !== 'druzstevne'
    }
  },
  // mounted() {
  //   if (this.stage == 'druzstevne' && this.contactForm.interests.length === 0) {
  //     this.contactForm.interests.push('druzstevne')
  //   }
  // },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.v$.contactForm[name];
      return $dirty ? !$error : null;
    },
    onUpdate: function(payload) {
      if (payload.isValid) {
        this.vuePhone.props.error = false
        this.vuePhone.isValid = true
      }
      this.contactForm["phone"] = payload.formattedNumber;
    },
    handleFocus() {
      if (this.dropdownActive) {
        this.dropdownActive = !this.dropdownActive
      }

      if (this.dropdownDruzstevneActive) {
        this.dropdownDruzstevneActive = !this.dropdownDruzstevneActive
      }
    },
    showDropdown() {
      this.dropdownActive = !this.dropdownActive;
    },
    showDropdownDruzstevne() {
      this.dropdownDruzstevneActive = !this.dropdownDruzstevneActive;
    },
    onVerify: function (response) {
      this.contactForm["g-recaptcha-response"] = response
    },
    async sendForm(e) {
      
      if (!this.recaptchaActive) {
        this.recaptchaActive = true
        return
      }
      const result = await this.v$.$validate()
      if (!result || !this.vuePhone.isValid) {
        if (!this.vuePhone.isValid) {
          this.vuePhone.props.error = true
          return
        }
        return
      }
      
      if (cookies.getCookieByName("first_interaction")) {
        this.contactForm["first_interaction_source"] = cookies.getCookieByName("first_interaction")['utm_source']
        this.contactForm["first_interaction_medium"] = cookies.getCookieByName("first_interaction")['utm_medium']
        this.contactForm["first_interaction_campaign"] = cookies.getCookieByName("first_interaction")['utm_campaign']
        this.contactForm["first_interaction_content"] = cookies.getCookieByName("first_interaction")['utm_content']
        this.contactForm["first_interaction_gclid"] = cookies.getCookieByName("first_interaction")['gclid']
        this.contactForm["first_interaction_fbclid"] = cookies.getCookieByName("first_interaction")['fbclid']
      }

      if (cookies.getCookieByName("last_interaction")) {
        this.contactForm["last_interaction_source"] = cookies.getCookieByName("last_interaction")['utm_source']
        this.contactForm["last_interaction_medium"] = cookies.getCookieByName("last_interaction")['utm_medium']
        this.contactForm["last_interaction_campaign"] = cookies.getCookieByName("last_interaction")['utm_campaign']
        this.contactForm["last_interaction_content"] = cookies.getCookieByName("last_interaction")['utm_content']
        this.contactForm["last_interaction_gclid"] = cookies.getCookieByName("last_interaction")['gclid']
        this.contactForm["last_interaction_fbclid"] = cookies.getCookieByName("last_interaction")['fbclid']
      }

      this.contactForm["browser"] = getBrowser(ua)
      this.contactForm["operating_system"] = getOS(ua)
      this.contactForm["language"] = navigator.language
      this.contactForm["timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone
      
      this.contactForm["internal_id"] = this.internalId ? this.internalId : ""
      if (this.stage) {
        if (this.stage === 'druzstevne' || this.selectedStage === 'bory4' || this.building == 'B2') {
          this.contactForm.interests = ['druzstevne']
        } else if (this.stage == 'bory5') {
          this.contactForm.interests = ['bory3b']
        } else {
          this.contactForm.interests = [this.stage]
        }
      }
      this.contactForm['ga_client_id'] = cookies.getCookieByName('_ga') ? cookies.getCookieByName('_ga').split('.').slice(-2).join(".") : 0

      const form = this.contactForm
      e.preventDefault()
      axios
          .post(`${process.env.VUE_APP_API_URL}/api/v1/contact-form`, form)
          .then(() => {
            const isDruzstevneOnly = this.stage === 'druzstevne' || this.building === 'B2'
            const interestsDruzstevne = this.contactForm.interests.includes('druzstevne')
            const interestsOther = this.contactForm.interests.some(i => i !== 'druzstevne')
            let formType = null
            if (isDruzstevneOnly || (interestsDruzstevne && !interestsOther)) {
              formType = 'druzstevne'
            } else if (interestsDruzstevne && interestsOther) {
              formType = 'mixed'
            }

            this.contactForm.name = ""
            this.contactForm.surname = ""
            this.contactForm.email = ""
            this.contactForm.phone = ""
            this.contactForm.interests = []
            this.contactForm['marketing_consent'] = false
            this.contactForm["g-recaptcha-response"] = ""
            this.contactForm["internal_id"] = ""
            this.contactForm["browser"] = ""
            this.contactForm["operating_system"] = ""
            this.contactForm["language"] = ""
            this.$router.push({
              name: 'FormularOdoslany',
              query: formType ? { type: formType } : {}
            })
          }).catch((error) => {
            this.$refs.recaptcha.reset()
            // handle error
            console.log(error.response.data.error);
            this.interestsError = !!error.response.data.error.interests;
            this.validation = true
      })
    }
  },
  created() {
    if (this.selectedStage) {
      this.contactForm.interests = [this.selectedStage]
    }
  },
}
</script>

<style lang="sass" scoped>
$md: 768px

.name-wrapper
  gap: 0 8px

.dropdown
  background: #fff
  padding: 14px 8px
  color: #6C757D
  cursor: pointer

.recaptcha
  display: none

  &.active
    display: block

.dropdown-content
  background: #fff
  padding: 8px 12px
  border-top: 0.5px solid rgba(0, 0, 0, 0.2)
  position: absolute
  width: 100%
  z-index: 999
  display: none

  &.active
    display: block

  .check-label
    display: block
    color: #6C757D
    font-weight: 400
    cursor: pointer
    margin: 0

    &:hover
      background: rgba(124, 182, 217, 0.15)

.custom-alert-box
  p
    margin-bottom: 0
    font-size: 16px
    font-weight: normal

.contact
  background: #576675
  h2
    font-size: 55px
    line-height: 60px
    margin-bottom: 20px
    margin-top: 16px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    @media (max-width: $md)
      display: inline
      padding-right: 5px
  .image-bg
    background: url(../../assets/images/contact-right.jpg) center/cover no-repeat
  .bv-no-focus-ring
    &:focus
      outline: none
  form
    .text-small
      font-size: 14px
      line-height: 20px
    .check-label
      font-size: 16px
      @media (max-width: $md)
        font-size: 14px
    .form-control
      height: 50px
      border: none
    .col-form-label
      margin-bottom: 5px
      font-size: 18px
    .custom-control-label
      font-size: 18px
    .small-font
      .custom-control-label
        font-size: 14px
    a
      color: var(--blue)
      font-size: 14px
      font-weight: 500
    button
      @media (max-width: $md)
        width: 100%
</style>